import React from "react";

const Loader = ({width="30px", height="30px"}) => {
  return (
    <div className="w-100 d-flex justify-content-center py-2">
      <div className="spinner-border" style={{width,height}} role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default Loader;
